/**
 * Zod schemas for Phone validation
 */

import { z } from 'zod';
import type { Phone } from './types';
import { generateUUID } from '@/util/uuid';

const PhoneTypeSchema = z.discriminatedUnion('kind', [
  z.object({ kind: z.literal('cell'), label: z.literal('Mobile') }),
  z.object({ kind: z.literal('home'), label: z.literal('Home') }),
  z.object({ kind: z.literal('phone'), label: z.literal('Phone') }),
  z.object({ kind: z.literal('work'), label: z.literal('Work') }),
  z.object({
    kind: z.literal('other'),
    label: z.literal('Other'),
    raw: z.string(),
  }),
]);

export const PhoneSchema = z
  .object({
    localId: z.string().optional(),
    value: z.string().min(1),
    type: PhoneTypeSchema.optional(),
    pref: z.number().optional(),
    pidPassthru: z.string().optional(),
  })
  .transform(data => ({
    ...data,
    localId: data.localId ?? generateUUID(),
  }));

/**
 * Validate a Phone object (or contact-phone shape from JSON).
 */
export function validatePhone(data: unknown): Phone | null {
  const result = PhoneSchema.safeParse(data);
  if (!result.success) {
    return null;
  }
  return result.data;
}
